import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';

var Typography = function Typography(_ref) {
  var _classNames;

  var className = _ref.className,
      style = _ref.style,
      size = _ref.size,
      color = _ref.color,
      strong = _ref.strong,
      semantic = _ref.semantic,
      sign = _ref.sign,
      theme = _ref.theme,
      ellipsis = _ref.ellipsis,
      children = _ref.children;
  return /*#__PURE__*/cloneElement(children, {
    className: classNames(children.props.className, className, "jmtd-typography-font-".concat(size), "jmtd-typography-strong-".concat(strong), (_classNames = {}, _defineProperty(_classNames, "jmtd-typography-theme-".concat(theme), !!theme), _defineProperty(_classNames, "jmtd-typography-color-".concat(color), !!color), _defineProperty(_classNames, "jmtd-typography-semantic-".concat(semantic), !!semantic), _defineProperty(_classNames, "jmtd-typography-sign-".concat(sign), !!sign), _defineProperty(_classNames, 'jmtd-typography-ellipsis', ellipsis), _classNames)),
    style: style
  });
};

Typography.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.string,
  // primary regular
  color: PropTypes.string,
  // primary、regular、placeholder、disabled
  strong: PropTypes.string,
  // base、medium、bold
  semantic: PropTypes.string,
  // info、success、helping、warning、danger
  sign: PropTypes.string,
  // underline、delete、italic、mark
  ellipsis: PropTypes.bool,
  theme: PropTypes.string // light dark

};
Typography.defaultProps = {
  id: null,
  className: '',
  style: {},
  size: 'primary',
  color: 'primary',
  strong: 'base',
  semantic: '',
  sign: '',
  ellipsis: false,
  theme: 'light'
};
export default Typography;